<template>
  <div class="user-management-container">
    <vab-query-form>
      <!-- <vab-query-form-left-panel :span="12">
        <el-button icon="el-icon-plus" type="primary" @click="handleEdit(null)">
          新增礼品
        </el-button>
      </vab-query-form-left-panel> -->
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="" prop="gameId">
            <el-select
              v-model="queryForm.gameId"
              placeholder="请选择游戏"
              class="mr-10"
            >
              <el-option
                v-for="item in gameList"
                :key="item.gameId"
                :label="item.title"
                :value="item.gameId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="queryForm.date"
              type="date"
              placeholder="选择日期"
              :clearable="false"
              value-format="YYYY-MM-DD"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="头像"
        prop="title"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <img :src="row.people.avatar" class="avatar-small" />
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="昵称"
        prop="people.name"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="封面"
        prop="title"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <img :src="row.gift.basic.avatar" class="avatar" />
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="礼品"
        prop="gift.title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="备注"
        prop="gift.basic.text"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="状态"
        prop="title"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <el-tag v-if="row.step === 1">未核销</el-tag>
          <el-tag type="warning" v-if="row.step === 4">已核销</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="核销日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ row.step === 4 ? moment(row.extra.finishTime).format('YYYY-MM-DD HH:mm:ss') : '' }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <el-button
            v-if="row.step === 1"
            type="text"
            @click="handleCheck(row)"
          >
            核销
          </el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
  </div>
</template>

<script>
//step = 1 未核销
//step = 4 已核销
import moment from 'moment'
import {
  findBattleGiftRecordList,
  findList,
  finishBattleGiftRecord,
} from '@/api/game'
export default {
  name: 'GiftRecord',
  data() {
    return {
      moment,
      list: [],
      gameList: [],
      defaultValue: '',
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        date: moment().format('YYYY-MM-DD'),
        gameId: '',
        keyword: '',
      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/game/giftRecord') {
        // this.fetchData()
        this.getGameList()
      }
    },
  },
  created() {
    this.getGameList()
    // this.fetchData()
  },
  methods: {
    handleEdit(row) {
      this.$refs['edit'].showEdit(row)
    },
    handleCheck(row) {
      this.$baseConfirm(
        `你确定要核销礼品：${row.gift.title} 吗`,
        null,
        async () => {
          await finishBattleGiftRecord({
            battleGiftRecordId: row.battleGiftRecordId,
            gameId: row.gameId,
          })
          this.$baseMessage(
            `核销礼品成功`,
            'success',
            false,
            'vab-hey-message-success'
          )
          this.queryData()
        }
      )
    },
    //获取游戏
    async getGameList() {
      const { list } = await findList({ page: 1, size: 1000 })
      this.gameList = list
      this.queryForm.gameId = list[0] && list[0].gameId
      this.fetchData()
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await findBattleGiftRecordList(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.avatar-small {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
.avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
